function loadMatomoScript(url: string, siteId: string) {
    const _paq = window._paq = window._paq || []
    _paq.push(['trackPageView'])
    _paq.push(['setTrackerUrl', `${url}/matomo.php`])
    _paq.push(['setSiteId', siteId])
    _paq.push(['disableCookies'])
    _paq.push(['enableLinkTracking'])
    const script = document.createElement('script')
    script.src = `${url}/matomo.js` // Replace with your Matomo instance URL
    document.getElementsByTagName('script')[0].parentNode?.insertBefore(script, null)
}

function setNavigationTracking(path: string) {
    if (window._paq) {
        window._paq.push(['setCustomUrl', window.location.href])
        window._paq.push(['setDocumentTitle', path])
        window._paq.push(['trackPageView'])
    }
}

export default defineNuxtPlugin((nuxtApp) => {
    const conf = nuxtApp.$config
    const matomoUrl: string | null = conf.public.matomo_url
    const matomoSiteId: string | null = conf.public.matomo_site_id
    if (import.meta.client && matomoUrl && matomoSiteId) {
        const _mtm = (window._mtm = window._mtm || [])
        const router = nuxtApp.$router as Router

        _mtm.push({ 'mtm.startTime': new Date().getTime(), 'event': 'mtm.Start' })

        loadMatomoScript(matomoUrl, matomoSiteId)

        router.afterEach((to: any) => {
            setNavigationTracking(to.path)
        })
    }
})
